import {
  Card,
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";

import UndoIcon from "@mui/icons-material/Undo";
import DeleteIcon from "@mui/icons-material/Delete";

import AnnotationColorSelector from "./annotation-color-selector";
import CloseLiveAnnotationControlButton from "./close-live-annotation-control-button";
import ControlPanelButton from "../../model-viewer/control-panel/components/control-panel-button";

interface AnnotationControlBarProps {
  color: string;
  colorOptions: string[];
  canReset: boolean;
  handleColorChange: (color: string) => void;
  onReset: () => void;
  onUndo: () => void;
}

const AnnotationControlBar: React.FC<AnnotationControlBarProps> = ({
  color,
  colorOptions,
  canReset,
  handleColorChange,
  onReset,
  onUndo,
}) => {

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          p: 1,
          pt: 0.3,
          alignItems: "center",
          borderRadius: 2,
          backdropFilter: `blur(20px)`,
          backgroundColor: `rgba(255, 255, 255, 0.8)`,
        }}
      >
        <Stack
          spacing={0}
          width={"100%"}
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="body2" sx={{ pb: 0.3 }} color="textSecondary">
            Live Annotation Controls
          </Typography>
          <Stack
            direction={"row"}
            spacing={1}
            width={"fit-content"}
            alignItems={"center"}
            alignContent={"center"}
          >
            <ControlPanelButton
              onClick={onUndo}
              disabled={!canReset}
              active={canReset}
              activeTooltip={"Undo Last Line"}
              inactiveTooltip={"Undo Last Line"}
              icon={<UndoIcon color="action" />}
              tooltipPlacement="bottom"
            />
            <ControlPanelButton
              onClick={onReset}
              disabled={!canReset}
              active={canReset}
              activeTooltip={"Clear Canvas"}
              inactiveTooltip={"Clear Canvas"}
              icon={<DeleteIcon color="action" />}
              tooltipPlacement="bottom"
            />
            <AnnotationColorSelector
              showLabel={false}
              showNames={false}
              selectedColor={color}
              onSelectColor={(event: SelectChangeEvent<string>) =>
                handleColorChange(event.target.value)
              }
              colorOptions={colorOptions}
            />
            <CloseLiveAnnotationControlButton />
          </Stack>
        </Stack>
      </Card>
    </Stack>
  );
};

export default AnnotationControlBar;
